export default "__VITE_ASSET__CC11tvO2__"